import { RegionsEnum } from "./regions.enum"

export enum RolesEnum {
  ADMIN = "ADMIN",
  BLOCKED = "BLOCKED",
  USER_ADMIN = "USER_ADMIN",
  KIOSK = "KIOSK",
  CONTRIBUTOR = "CONTRIBUTOR",
  EDITOR = "EDITOR",
  MODERATOR = "MODERATOR",
}

export type RegionRoles = {
  [K in RegionsEnum]: RolesEnum[]
}
